
<div>
    <a v-if="sortable.first" class="sort-button" @click="onFirst" >
        <div
            class="v-flex"
            style="justify-content: center"
            :class="sortFirst ? 'sort-selected' : ''"
        >
            <div>
                {{ $t(group + '.' + first) }}
            </div>
            <div v-if="sortFirst" style="float: right">
                <v-icon class="icon-sort">{{ sortFirst }}</v-icon>
            </div>
        </div>
    </a>

    <div v-if="!sortable.first">
        {{ $t(group + '.' + first) }}
    </div>

    <a v-if="second && sortable.second" class="sort-button" @click="onSecond">
        <div
            class="v-flex"
            style="justify-content: center"
            :class="sortSecond ? 'sort-selected' : ''"
        >
            <div>
                {{ $t(group + '.' + second) }}
            </div>
            <div v-if="sortSecond" style="float: right">
                <v-icon class="icon-sort" color="white">{{ sortSecond }}</v-icon>
            </div>
        </div>
    </a>

    <div v-if="second && !sortable.second" >
        {{ $t(group + '.' + second) }}
    </div>
</div>
